import React, { useCallback, useEffect, useMemo } from "react";
import "./App.css";
import { getRoutes } from "./router/Routes";
import Toast from "../src/common/Toast";
import config from '../src/config/index';
import { RouterProvider } from "react-router-dom";
import { useSelector } from "react-redux";
import { gtag, install } from 'ga-gtag';
import { useDispatch } from "react-redux";
import { setSystemUIConfig } from "./actions/users";
import { UI_CONFIG_LOADING } from "./types/loading";
import { OfflineMessage } from "./common/OfflineMessage";
import { isLogged } from "./utils/common";
import { isMobileView } from "./utils/utils";

const script = document.createElement("script")
script.src = config.bankopen.paymenturl
script.async = true
document.body.appendChild(script)



function App() {

    const dispatch = useDispatch()

    const dynamicSystemUI = useCallback(async () => {
        if (!window.location.host.includes('localhost') && window.location.host !== config.ui4Domain) {
            const host = window.location.host;
            const configUrl = `https://media.scogo.in/whitelabel.configs.scogo.in/configs/${host}.json`
            dispatch({ type: UI_CONFIG_LOADING, payload: true });
            let response = await fetch(configUrl)
            response = await response.json()
            dispatch(setSystemUIConfig({ logoUrl: response.homepage.logoUrl, header: response.homepage.header, customer_id: response.homepage.customerId, support_track_attachment_title: response.homepage.support_track_attachment_title }));
            dispatch({ type: UI_CONFIG_LOADING, payload: false });
            let favicon = document.getElementById('favicon')
            favicon.href = response.favicon
        }
    }, [dispatch])


    useEffect(() => {
        dynamicSystemUI()
    }, [dynamicSystemUI])


    install(config.gTagId)
    gtag('config', config.gTagId);

    const newLoggedUserData = useSelector(state => state.auth.newLoggedUserData);
    const sidebarList = useSelector(state => state.utils.sidebarList);
    const isUserProfileLoading = useSelector(state => state.loading.isUserProfileLoading);
    const isSerUrl = window.location.host === config.serUrl;

    const isLoggedIn = isLogged();
    const isPublicPavRoute = window.location.pathname.startsWith('/pav/');

    const isLoggedUserFetching = isLoggedIn && !newLoggedUserData && isUserProfileLoading;

    const memoizedRoutes = useMemo(() => {
        const routes = getRoutes({ newLoggedUserData, isLoggedIn, sidebarList })
        return routes
    }, [newLoggedUserData, isLoggedIn, sidebarList])

    return (
        <>
            {isSerUrl ? <RenderSer /> :
                <>
                    <OfflineMessage />
                    <Toast />
                    {isLoggedUserFetching && !isPublicPavRoute ? <></> : <RouterProvider router={memoizedRoutes} />}
                </>
            }
        </>
    );
}

export default App;


const RenderSer = () => {
    useEffect(() => {
        document.title = "Scogo SER";
    }, []);
    return <div className="h-[100vh] w-[100%] overflow-hidden">

        {isMobileView ? <>
            <div className="border-1 border-scogoprimary h-[100%] ">

                <iframe src="https://media.scogo.in/media/popup-images/ser_product_brochure.pdf" width="100%" height="100%">
                </iframe>
            </div>
        </> : <object data="https://media.scogo.in/media/popup-images/ser_product_brochure.pdf" type="application/pdf" width="100%" height="100%">
            <p>It appears you don't have a PDF plugin for this browser. You can <a href="https://media.scogo.in/media/popup-images/ser_product_brochure.pdf">click here to download the PDF file.</a></p>
        </object>}

    </div >
}




export const RenderAnnouncement = () => {
    useEffect(() => {
        document.documentElement.style.setProperty('--announcement-bar-height', isMobileView ? '60px' : '35px');
    }, []);

    return (
        <div className={`md:px-10 px-4 text-[11px] bg-scogoprimary hover:underline flex justify-center items-center text-center text-white w-full overflow-hidden ${isMobileView ? 'h-[60px]' : 'h-[35px]'}`} style={{ position: 'fixed', top: '0', left: '0', right: '0', zIndex: '1000' }}>
            <a rel="noreferrer" target="_blank" href="https://scogo.ai/" style={{ color: '#fff', textDecoration: 'none' }}>{`🚀 Launching SIA : Your Smart, Multilingual and Multichannel Customer Support AI Agent ! Launch Your Free AI Agent in Just 5 Seconds . Try It Now ➜`}</a>
        </div>
    )
};


const Loading = () => {
    return <div className="h-[100vh] w-[100%] overflow-hidden">
        <div className="flex justify-center items-center h-full">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-scogoprimary"></div>
        </div>
    </div>
}
